import { useState } from "react";
import { useSelector } from "react-redux";
import MenteeHeader from "../../components/MenteeHeader";
import Purchases from "./Purchases";
import IndustryHub from "./IndustryHub";
import Marketplace from "./MarketPlace";
import ScormCourseList from "../Scorm/ScormCourseList";
import { SCORM_ENABLED } from "../../helpers/scorm/featureFlag";
import useDashboardActiveTab from "../../hooks/useDashboardActiveTab";

export default function MentorDashboard() {
  const role = useSelector((state) => state.auth?.loginDetails?.profile?.role);
  const [searchTerm, setSearchTerm] = useState("");
  const activeTab = useDashboardActiveTab("learn");

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <>
      <MenteeHeader
        role={role?.join(", ")}
        active={activeTab}
        searchTerm={searchTerm}
        handleSearchChange={handleSearchChange}
      />
      {activeTab === "learn" && <Marketplace searchTerm={searchTerm} />}
      {activeTab === "myevents" && <Purchases searchTerm={searchTerm} />}
      {SCORM_ENABLED && activeTab === "training" && <ScormCourseList />}
      {activeTab == "industryhub" && <IndustryHub searchTerm={searchTerm} />}
    </>
  );
}
